import styled from 'styled-components';
export const Item = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.6rem;
  margin-top: 1rem;
  padding: 1.6rem;
  background-color: #fff;
  border: 0.1rem solid var(--light-grey, #e7e6eb);
  border-radius: 1.6rem;

  ${({ theme: { visitorInfoBand } }) => visitorInfoBand}
`;
export const Content = styled.div `
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex: 1;
  min-width: 0;
`;
export const Name = styled.div `
  font-size: 1.6rem;
  line-height: normal;
  color: var(--text, #000);

  ${({ theme: { attendeeTitle } }) => attendeeTitle}
`;
export const Note = styled.div `
  font-size: 1.2rem;
  line-height: normal;
  color: var(--text, #000);

  ${({ theme: { attendeeCopy } }) => attendeeCopy}

  p {
    margin: 0;
  }
`;
export const NoteLabel = styled.strong `
  font-weight: 800;
`;
export const Price = styled.span `
  flex-shrink: 0;
  font-size: 1.2rem;
  line-height: normal;
  color: var(--text, #000);
  text-transform: uppercase;

  ${({ theme: { visitorInfoBandPrice } }) => visitorInfoBandPrice}
`;
export default {
    Item,
    Content,
    Name,
    Note,
    NoteLabel,
    Price,
};
